import { Component, Input, OnChanges } from '@angular/core';
import { AchievementTier } from '../../models/achievement.model';
import { GamificationAchievement } from '../../models/gamification-bootstrap.model';
import { mapAchievementToLadder } from '../../models/gamification-view.mapper';

export interface WithinReachView {
  key: string;
  title: string;
  iconCssClass: string;
  tier: AchievementTier | null;
  statusLabel: string;
  percent: number;
  progressLabel: string;
}

@Component({
  selector: 'app-achievements-within-reach-mock',
  templateUrl: './achievements-within-reach-mock.component.html',
  styleUrls: ['./achievements-within-reach-mock.component.scss']
})
export class AchievementsWithinReachMockComponent implements OnChanges {
  @Input() loading = true;
  @Input() achievements: GamificationAchievement[] = [];

  readonly skeletonCards = [1, 2, 3];
  achievementViews: WithinReachView[] = [];

  ngOnChanges(): void {
    this.achievementViews = (this.achievements || []).map(achievement => {
      const ladder = mapAchievementToLadder(achievement);
      return {
        key: ladder.key,
        title: ladder.title,
        iconCssClass: ladder.iconCssClass,
        tier: ladder.tier,
        statusLabel: ladder.statusLabel,
        percent: ladder.percent,
        progressLabel: ladder.rungs.find(rung => rung.state === 'current')?.progressLabel || 'Complete'
      };
    });
  }

  trackByKey(index: number, achievement: WithinReachView): string {
    return achievement.key;
  }
}
